export default __webpack_public_path__ + "static/media/indiaCovid19Eng.876ce81a.jpg";